import React, { useState, useEffect, createContext, useContext } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';
import RequestAuditModal from './RequestAuditModal';
import FrameworkDownloadModal from './FrameworkDownloadModal';
import TalkToResearcherModal from './TalkToResearcherModal';
import BotpressChat from './BotpressChat';

const ModalContext = createContext();

export const useModals = () => useContext(ModalContext);

const Layout = ({ children }) => {
    const [isAuditModalOpen, setIsAuditModalOpen] = useState(false);
    const [isFrameworkModalOpen, setIsFrameworkModalOpen] = useState(false);
    const [isResearcherModalOpen, setIsResearcherModalOpen] = useState(false);
    const location = useLocation();
    const navigate = useNavigate();

    const scrollToSection = (id) => {
        if (location.pathname !== '/') {
            navigate('/#' + id);
            return;
        }
        const element = document.getElementById(id);
        if (element) {
            element.scrollIntoView({ behavior: 'smooth' });
        }
    };

    useEffect(() => {
        if (location.hash) {
            const id = location.hash.replace('#', '');
            setTimeout(() => {
                const element = document.getElementById(id);
                if (element) {
                    element.scrollIntoView({ behavior: 'smooth' });
                }
            }, 100);
        } else {
            window.scrollTo(0, 0);
        }
    }, [location]);

    const value = {
        setIsAuditModalOpen,
        setIsFrameworkModalOpen,
        setIsResearcherModalOpen
    };

    return (
        <ModalContext.Provider value={value}>
            <div className="layout-wrapper">
                <Header setIsAuditModalOpen={setIsAuditModalOpen} />

                <main>
                    {children}
                </main>

                <Footer
                    scrollToSection={scrollToSection}
                    setIsFrameworkModalOpen={setIsFrameworkModalOpen}
                />

                <RequestAuditModal isOpen={isAuditModalOpen} onClose={() => setIsAuditModalOpen(false)} />
                <FrameworkDownloadModal isOpen={isFrameworkModalOpen} onClose={() => setIsFrameworkModalOpen(false)} />
                <TalkToResearcherModal isOpen={isResearcherModalOpen} onClose={() => setIsResearcherModalOpen(false)} />
                <BotpressChat />
            </div>
        </ModalContext.Provider>
    );
};

export default Layout;
